/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
// import { RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import { DownloadOutlined, MoreOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Space, Input, Menu, Dropdown, message, Tag } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import {
  SaleOrderCustomerListReq,
  DeleteSaleOrderCustomerReq,
  SaleOrderCustomerData,
} from 'Store/saleorder-customer/types'
import { customerListAPI, deleteSaleOrderCustomerAPI } from 'Store/saleorder-customer/api'
import {
  selectSaleOrderCustomerList,
  selectSaleOrderCustomerListEvent,
  selectSaleOrderCustomerActionEvent,
} from 'Store/saleorder-customer/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/saleorder-customer/actions'
import {
  formatDateTime,
  getBankName,
  getDefaultStatus,
  getPriceConfigsMenuSelect,
  mapWordingStockMovementReport,
  numberWithComma,
  toDateQuery,
} from 'helpers/format'
import { FranchiseTag, StatusTag } from 'Components/utilities'
import { DefaultStatus, menuUserGroup } from 'helpers/constanst'
import { ConfirmDailog, LoadingView } from 'Components/modal'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import BannerDetail from './detail'
import EventModal from 'Components/modal/EventModal'
import { Pagination } from 'Components/Pagination'
import theme, { MyTheme } from 'Components/common/Theme'
import ConfirmWithChild from 'Components/modal/ConfirmWithChild'
import { MultiUploadForm, RangeDateItem, SelectItem } from 'Components/form'
import Orders from './components/Orders'
import { selectDatas } from 'Store/config/selector'
import { APIPath } from 'services/APIPath'
import Axios from 'axios'
import downloadCSVFile from 'helpers/export'
import { appConfig, themeConfig } from 'config'

type Props = {} & ReduxProps

const Customers: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, list, event, configs } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [orderDrawer, setOrderDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [showInfo, setShowInfo] = useState(false)
  const [selectedSaleOrderCustomer, setSelectedSaleOrderCustomer] = useState(
    undefined as SaleOrderCustomerData | undefined,
  )
  const [exporting, setExporting] = useState(false)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')
  const isHQ = currentUser?.activeMerchant?.is_hq === true

  const [filter, setFilter] = useState({
    keyword: '',
    type: '',
    start_date: '',
    end_date: '',
    order_by: 'id',
    sort: 'desc',
    customer_type: '',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = list.meta
  const datas = list.data
  const priceLabel = configs?.value.price_labels || []

  const onGetList = (): void => {
    const req: SaleOrderCustomerListReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      all: false,
      keyword: filter.keyword,
      type: filter.type,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      order_by: filter.order_by || 'id',
      sort: filter.sort || 'desc',
      customer_type: filter.customer_type || '',
    }
    dispatch(customerListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onExport = (): void => {
    setExporting(true)
    const req: SaleOrderCustomerListReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      all: true,
      keyword: filter.keyword,
      type: filter.type,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      order_by: filter.order_by,
      sort: filter.sort,
    }
    const endPoint = appConfig.backofficeEndpoint + `${APIPath.customerList}?export=true`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || '',
        'x-auth-mid': currentUser?.activeMerchant?.id || 0,
      },
    }
    Axios.post(endPoint, req, header)
      .then((res: any) => {
        const reportData = mapWordingStockMovementReport(res.data)
        const fileName = `รายงานลูกค้า/คู่ค้า`
        downloadCSVFile(reportData, fileName)
        setExporting(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const onDelete = (id: number): void => {
    const req: DeleteSaleOrderCustomerReq = {
      id,
    }
    dispatch(
      deleteSaleOrderCustomerAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''),
    )
  }

  const getConfigName = (key: string): string => {
    const result = priceLabel && priceLabel.find(item => item.name === key)
    return `${result?.value || ''} ${result?.description ? '(' + result?.description + ')' : ''}`
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetList()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickCreate = () => {
    setPageMode('create')
    setSelectedID(0)
    onOpenDrawer()
  }

  const onClickEdit = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDrawer()
  }

  const onClickDelete = (id: number) => {
    setPageMode('deleted')
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onConfirmDelete = () => {
    onDelete(selectedID)
    onCloseConfirmDelete()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetList()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetList()
  }

  const renderStatus = (status: DefaultStatus) => (
    <StatusTag isPass={status === DefaultStatus.ACTIVE} text={getDefaultStatus(status)} />
  )

  const menu = (record: SaleOrderCustomerData) => {
    return (
      <Menu>
        {record?.customer_type !== 'franchise' && (
          <Menu.Item
            onClick={() => {
              onClickEdit(record.id)
              setSelectedID(record.id)
              setSelectedSaleOrderCustomer(record)
            }}
          >
            แก้ไขข้อมูล
          </Menu.Item>
        )}

        <Menu.Item
          onClick={() => {
            setSelectedID(record.id)
            setSelectedSaleOrderCustomer(record)
            setOrderDrawer(true)
          }}
        >
          ข้อมูลรายการสั่งซื้อ
        </Menu.Item>
      </Menu>
    )
  }

  const renderActionButton = (text: string, record: any) => (
    <Space size="middle">
      {/* <ActionButton
        text=""
        icon={<EditOutlined />}
        label="แก้ไข"
        action="edit"
        onClick={() => onClickEdit(record.id)}
      /> */}
      <Dropdown key="more" overlay={menu(record)} trigger={['click', 'hover']}>
        <ActionButton text="" icon={<MoreOutlined />} label="" action="edit" />
      </Dropdown>
    </Space>
  )

  const renderCompanyInfo = (name: string, record: SaleOrderCustomerData) => (
    <LinkNo
      color={theme.colors.black}
      onClick={() => {
        setSelectedSaleOrderCustomer(record)
        setShowInfo(true)
      }}
    >
      {name}
    </LinkNo>
  )

  const renderName = (name: string, record: SaleOrderCustomerData) => {
    const isFranchise = record?.customer_type === 'franchise'
    return <FranchiseTag text={name} isFranchise={isFranchise} />
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '60px',
    },
    {
      title: 'เบอร์โทรศัพท์',
      dataIndex: 'mobile',
      key: 'mobile',
      sorter: true,
      render: renderCompanyInfo,
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      render: renderName,
    },
    {
      title: 'ประเภทลูกค้า',
      dataIndex: 'type',
      key: 'type',
      sorter: true,
      render: (value: any) => getConfigName(value),
    },
    {
      title: 'เครดิตจ่ายหนี้ (วัน)',
      dataIndex: 'credit_term',
      key: 'credit_term',
      align: 'right',
      sorter: true,
      render: (value: any) => `${numberWithComma(value)}`,
    },
    {
      title: 'เครดิตที่ได้',
      dataIndex: 'credit_limit',
      key: 'credit_limit',
      sorter: true,
      render: (value: any) => `${numberWithComma(value, true)}`,
      align: 'right',
    },
    {
      title: 'ยอดค้างชำระ',
      dataIndex: 'current_debt',
      key: 'current_debt',
      sorter: true,
      render: (value: any) => `${numberWithComma(value, true)}`,
      align: 'right',
    },
    {
      title: 'เครดิตคงเหลือ',
      dataIndex: 'credit_remain',
      key: 'credit_remain',
      sorter: true,
      render: (value: any) => `${numberWithComma(value, true)}`,
      align: 'right',
    },
    {
      title: '',
      dataIndex: 'width',
      key: 'width',
      width: '20px',
      align: 'right',
    },
    {
      title: 'วันที่สร้างข้อมูล',
      key: 'created_at',
      dataIndex: 'created_at',
      sorter: true,
      width: '100px',
      render: (value: any) => formatDateTime(value || ''),
    },
    {
      title: '',
      key: 'action',
      width: '100px',
      render: renderActionButton,
      align: 'center',
    },
  ]

  const renderInfo = (title: string, value: any) => {
    return (
      <Row>
        <Col lg={10} xs={12}>
          <InfoTitle>{title} </InfoTitle>
        </Col>
        <Col lg={14} xs={12}>
          <InfoValue>{value || '-'}</InfoValue>
        </Col>
      </Row>
    )
  }

  const renderWithdrawInfo = () => {
    return (
      <WithdrawWrapper>
        <Row gutter={[16, 8]}>
          <Col span={24}>
            {renderInfo('ชื่อลูกค้า/คู่ค้า', selectedSaleOrderCustomer?.name)}
            {renderInfo('เบอร์โทรศัพท์', selectedSaleOrderCustomer?.mobile)}
            {renderInfo('อีเมล', selectedSaleOrderCustomer?.email)}
            {renderInfo('ที่อยู่', selectedSaleOrderCustomer?.address)}
            {renderInfo('ประเภทลูกค้า', getConfigName(selectedSaleOrderCustomer?.type || ''))}
          </Col>
          <Col span={24}>ข้อมูลสำหรับออกใบกำกับภาษีรูปแบบเต็ม</Col>
          <Col span={24}>
            {renderInfo('ชื่อ', selectedSaleOrderCustomer?.tax_name)}
            {renderInfo('เลขประจำตัวผู้เสียภาษี', selectedSaleOrderCustomer?.tax_number)}
            {renderInfo('เบอร์โทรศัพท์', selectedSaleOrderCustomer?.tax_mobile)}
            {renderInfo('ที่อยู่', selectedSaleOrderCustomer?.tax_address)}
          </Col>
          <Col span={24}>ข้อมูลเครดิต</Col>
          <Col span={24}>
            {renderInfo(
              'ระยะเวลาชำระเงิน',
              `${numberWithComma(selectedSaleOrderCustomer?.credit_term || 0)} วัน`,
            )}
            {renderInfo(
              'จำนวนเครดิต',
              `${numberWithComma(selectedSaleOrderCustomer?.credit_limit || 0, true)} บาท`,
            )}
          </Col>
          <Col span={24}>
            <MultiUploadForm
              token={currentUser.accessToken}
              onUpdateData={() => {}}
              files={selectedSaleOrderCustomer?.reference_docs || []}
              folder="supplier-account"
              listType="text"
              isPrivate={true}
              name="account_book_bank"
              description=""
              isRequired={false}
              isError={false}
              label="เอกสาร"
              readOnly={true}
            />
          </Col>
        </Row>
      </WithdrawWrapper>
    )
  }

  const InfoModal = (
    <ConfirmWithChild
      title={'ข้อมูลลูกค้า/คู่ค้า'}
      isShow={showInfo}
      handleOk={() => {}}
      handleCancel={() => setShowInfo(false)}
      child={renderWithdrawInfo()}
      hasConfirm={false}
      hasCancel={false}
      cancelBtnTxt="ปิด"
    />
  )

  const DetailDrawer = (
    <BannerDetail
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
      disabled={selectedSaleOrderCustomer?.customer_type === 'franchise'}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="top" gutter={[8, 8]}>
        <Col xs={24} md={18}>
          <Row gutter={[8, 8]}>
            <Col xs={24} md={6}>
              <SearchInput
                placeholder="ค้นหาชื่อลูกค้า,เบอร์โทรศัพท์"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col xs={24} md={6}>
              <SelectItem
                name={'type'}
                label={''}
                isRequired={true}
                value={filter.type}
                menu={getPriceConfigsMenuSelect(configs?.value?.price_labels || [], 'value', 'name')}
                placeHolder={'ประเภทลูกค้า'}
                onChange={(val: any): void => onFilter('type', val)}
              />
            </Col>
            {isHQ && (
              <Col xs={24} md={6}>
                <SelectItem
                  name={'customer_type'}
                  label={''}
                  isRequired={true}
                  value={filter.customer_type}
                  menu={menuUserGroup}
                  placeHolder={'กลุ่มลูกค้า'}
                  onChange={(val: any): void => onFilter('customer_type', val)}
                />
              </Col>
            )}
            <Col md={6} xs={24}>
              <RangeDateItem
                placeHolder={['วันที่เริ่มต้น', 'สิ้นสุด']}
                onChange={handleChangeDate}
                startDate={filter.start_date}
                endDate={filter.end_date}
              />
            </Col>
            <Col>
              <Space size="middle">
                <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
              </Space>
            </Col>
            <Col>
              <Space size="middle">
                <PrimaryButton
                  text="รายงานลูกค้า/คู่ค้า"
                  icon={<DownloadOutlined />}
                  onClick={onExport}
                  loading={exporting}
                />
              </Space>
            </Col>
          </Row>
        </Col>
        <Col>
          <Space size="middle">
            <PrimaryButton text="เพิ่มลูกค้า/คู่ค้า" icon={<PlusOutlined />} onClick={onClickCreate} />
          </Space>
        </Col>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const OrdersDrawer = (
    <Orders
      id={selectedID}
      visible={orderDrawer}
      onCloseDrawer={() => setOrderDrawer(false)}
      onSuccess={() => {}}
      customer={selectedSaleOrderCustomer}
    />
  )

  return (
    <>
      <HomePageLayout selected="customers" title="ข้อมูลลูกค้า/คู่ค้า" label="">
        {FilterContent}
        <LoadingView isShow={exporting} />
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={PaginationContent}
          size="small"
          onSort={(field: string, order: string) => {
            onSort(field, order)
          }}
        />
        {LoadingModal}
        {DetailDrawer}
        {ConfirmDeleteModal}
        {InfoModal}
        {OrdersDrawer}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectSaleOrderCustomerList(state),
    listEvent: selectSaleOrderCustomerListEvent(state),
    event: selectSaleOrderCustomerActionEvent(state),
    configs: selectDatas(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const WithdrawWrapper = styled.div`
  padding: 10px;
  text-align: left;
`
const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const InfoValue = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`
export default connect(mapStateToProps)(Customers)
